import React, { Fragment, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { CaseFormField } from "../../CaseGenerator";
import { useFormikContext } from "formik";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export const CaseStep = (props: any) => {
  const {
    fields,
    layout,
    activeStep,
    handleButtonMatricolaContatoreCaseClick,
    buttonVolturaIsClick,
    validationSchema,
  } = props;
  const { values, setFieldValue } = useFormikContext();
  const state = useSelector((state) => state);
  const { t } = useTranslation();

  const { fields: layoutFields, component: Component, hooks } = layout;

  useEffect(() => {
    if (hooks && hooks.pre) {
      hooks.pre(values, setFieldValue, state);
    }

    // scroll to top when changing the step
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    return function postHook() {
      if (hooks && hooks.post) {
        hooks.post(values, setFieldValue, state);
      }
    };

    // eslint-disable-next-line
  }, [layout]);

  if (Component) {
    return <Component {...props} />;
  }

  const isConditionMet = (conditionProps: any | null) => {
    if (!conditionProps) {
      return true;
    }

    if (typeof conditionProps === "function") {
      return conditionProps(values);
    }

    const conditions = conditionProps;
    if (conditions.length === 0) {
      return true;
    }
    let allowed: boolean;
    const validation = conditions.map((condition: any) => {
      const valuesObj = values as Record<string, any>;
      return (
        valuesObj[condition.if] === condition.is ||
        valuesObj[condition.if] === condition.or
      );
    });
    allowed = validation.every((v: any) => v === true);
    return allowed;
  };
  return (
    <Fragment key={layout.title}>
      {!layout.noMandatoryLegend && (
        <p className={"case-step-mandatory-fields-legend paragraph-small-fs9"}>
          {t("mandatory.fields.legend")}
        </p>
      )}
      {layout.title && (
        <h2 className={"case-step-title"}>
          {layout.alternativeTitle &&
          isConditionMet(layout.alternativeCondition)
            ? layout.alternativeTitle
            : layout.title}
        </h2>
      )}
      {layout.description && (
        <p className={"case-step-description"}>{layout.description}</p>
      )}
      <Row>
        {layoutFields &&
          layoutFields.map((item: any, index: any) => {
            const gridProps = item.grid;
            const conditionProps = item.condition || null;
            const fieldProps = fields[item.fieldName];
            const finalFieldProps = { ...fieldProps, validationSchema };
            const conditionMet = isConditionMet(conditionProps);
            let handleButtonMatricolaContatoreCaseClickConst = true;
            if (handleButtonMatricolaContatoreCaseClick) {
              handleButtonMatricolaContatoreCaseClickConst =
                handleButtonMatricolaContatoreCaseClick(
                  index,
                  buttonVolturaIsClick,
                  activeStep
                );
            }
            return (
              conditionMet &&
              handleButtonMatricolaContatoreCaseClickConst && (
                <Col {...gridProps} key={index} className={item.className}>
                  {!item.fieldName && item.text}
                  {item.fieldName && <CaseFormField {...finalFieldProps} />}
                </Col>
              )
            );
          })}
        {layout.content && (
          <div className="col-12">
            <div className={"content"}>{layout.content}</div>
          </div>
        )}
      </Row>
    </Fragment>
  );
};
